import React from "react"
import styled from "styled-components"
import Wave from "./Wave"

const SectionGroup = styled.div`
  background: #1890ff;
  height: 850px;
  background-size: cover;
  display: grid;
  grid-template-rows: 200px auto;
  gap: 20px;
  position: relative;

  @media (max-width: 800px) {
    height: 920px;
  }

  @media (max-width: 640px) {
    height: 1120px;
  }
`

const SectionTitle = styled.h3`
  font-size: 60px;
  text-align: center;
  color: white;
`

const SectionTextContainer = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  margin-top: 150px;

  @media (max-width: 640px) {
    padding: 0 20px;
  }
`
const SectionText = styled.p`
  justify-self: center;
  color: white;
  font-weight: 600;
  max-width: 700px;
  text-align: justify;
  margin-top: -20px;
`
const WaveBottom = styled.div`
  position: absolute;
  width: 100%;
  bottom: -6px;
`

const WaveTop = styled.div`
  position: absolute;
  width: 100%;
  top: -6px;
  transform: rotate(180deg);
`

const IllustrationsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, auto);
  justify-self: center;
`

const Illustration = styled.img`
  height: 100px;
  width: 100px;
  justify-self: center;
  margin: 0 20px;

  @media (max-width: 640px) {
    margin: 0 5px;
  }
`

const Section = () => (
  <SectionGroup>
    <WaveTop>
      <Wave />
    </WaveTop>
    <WaveBottom>
      <Wave />
    </WaveBottom>

    <SectionTextContainer>
      <SectionTitle>Sobre Nosotros</SectionTitle>
      <SectionText>
        Ganadores del Hackathon 2.0 de la UTP bajo la categoría "Transparencia
        Gubernamental".
        <br />
        <br /> Firmes creyentes que los gobiernos son meros entes
        administrativos totalmente subordinados al servicio de la nación y no
        entes con colmo propio.
      </SectionText>

      <IllustrationsContainer>
        <Illustration
          src={require("../static/images/undraw_programming_2svr.svg")}
        />
        <Illustration
          src={require("../static/images/undraw_coding_6mjf.svg")}
        />
        <Illustration
          src={require("../static/images/undraw_hacker_mind_6y85.svg")}
        />
      </IllustrationsContainer>
    </SectionTextContainer>
  </SectionGroup>
)

export default Section
